<template>
  <div class="consumable-log">
    <section class="section">
      <b-loading :active="isLoading"></b-loading>
      <div class="container">
        <div class="columns">
          <div class="column is-full">
            <div class="box">
              <div class="columns is-mobile" style="margin-top: 16px">
                <div class="column">
                  <header class="heading">
                    <p class="modal-card-title">{{ pageTitle }}</p>
                  </header>
                </div>
              </div>
              <div class="columns" style="margin-top: 16px">
                <div class="column is-full">
                  <b-field required :label="$t('consumable-log-view.select-date-title')">
                    {{ getFormattedDate(selected_date) }}
                  </b-field>
                  <b-field required :label="$t('consumable-log-view.resource')">
                    <b-taginput
                        v-if="isInNewMode"
                        maxtags="1"
                        v-model="consumablesTags"
                        :data="filteredConsumables"
                        :loading="false"
                        :has-counter="false"
                        :open-on-focus="true"
                        autocomplete
                        field="resource"
                        icon="cart-variant"
                        :remove-on-keys=[]
                        :placeholder="$t('consumable-log-view.resource-placeholder')"
                        tabindex="2"
                        @typing="getFilteredConsumables">
                    </b-taginput>
                    <label v-else>{{ log_data.parent.resource }}</label>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column is-half">
                  <b-field required :label="quantityTitle">
                    <b-numberinput :editable="true" tabindex="3" v-model="quantity" min="0" step="0.1">
                    </b-numberinput>
                  </b-field>
                </div>
                <div class="column is-half">
                  <b-field style="margin-top: 40px;">
                    {{remainingQuantity}}
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full">
                  <b-field :label="$t('consumable-log-view.text')">
                    <b-input v-model="text"
                              :placeholder="$t('consumable-log-view.text-placeholder')" tabindex="4"
                              type="textarea"></b-input>
                  </b-field>
                  <label v-if="!isFormValid"
                          class="required-field">{{ $t('validation.consumable-log-form') }}
                  </label>
                </div>
              </div>
              <div class="columns is-mobile" style="margin-top: 16px">
                <div class="column is-narrow">
                  <b-button tabindex="10" class="button" @click="cancelClicked" icon-left="close-thick">
                    {{ $t('common.cancel') }}
                  </b-button>
                </div>
                <div class="column is-narrow">
                  <b-button tabindex="11" class="button is-primary" @click="saveClicked" icon-left="content-save">
                    {{ $t('common.save') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "ConsumableLog",
  props: {
    'project_id': {
      type: String,
    },
    'log_data': {},
    'consumables_data': {},
    'selected_date': {}
  },
  data() {
    return {
      consumablesTags: [],
      filteredConsumables: this.consumables_data,
      quantity: 0,
      resource: "",
      text: "",
      isLoading: false,
      isFormValid: true
    }
  },
  methods: {
    createConsumableLog: function (updateData) {
      this.isLoading = true
      const functions = firebase.app().functions("europe-west3");
      const insertConsumableLogFunction = functions.httpsCallable(this.getSubmitEndpoint());
      updateData.action = "insert_log";
      insertConsumableLogFunction(updateData).then((result) => {
        console.log("create consumable log result: ", result.data);
        this.showSuccess(this.$t('messages.consumable-log-created'));
        this.$emit('consumableLogAdded');
      }).catch((error) => {
        this.showError(error.message)
        console.log("Error writing document: ", error);
      });
      this.isLoading = false
    },
    updateConsumableLog: function (updateData) {
      this.isLoading = true
      const functions = firebase.app().functions("europe-west3");
      const updateConsumableLogFunction = functions.httpsCallable(this.getSubmitEndpoint());
      updateData.action = "update_log";
      updateConsumableLogFunction(updateData).then((result) => {
        this.isLoading = false
        console.log("update consumable log result: ", result.data);
        this.showSuccess(this.$t('messages.consumable-log-updated'));
        this.$emit('consumableLogUpdated');
      }).catch((error) => {
        this.isLoading = false
        this.showError(error.message)
        console.log("Error writing document: ", error);
      });
    },
    getFilteredConsumables(text) {
      this.filteredConsumables = this.consumables_data.filter((option) => {
        return option.consumable.resource
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0
      })
    },
    validateForm() {
      return this.selected_date != null && this.quantity != null && this.quantity !== 0
            && ((this.isInNewMode && this.consumablesTags != null && this.consumablesTags.length > 0) || (!this.isInNewMode && this.resource != ""));
    },
    /*
     UI Events
     */
    cancelClicked: function () {
      this.$emit('close');
    },
    backClicked: function () {
      this.$router.back();
    },
    saveClicked: function () {
      this.isFormValid = true
      if (!this.validateForm()) {
        this.isFormValid = false
        return
      }
      // setting current time to the selected date
      const currentDate = new Date()
      this.selected_date.setHours(currentDate.getHours(), currentDate.getMinutes(), currentDate.getSeconds(), currentDate.getMilliseconds())
      const dataFieldsToUpdate = {
        project_id: this.project_id,
        quantity: this.quantity,
        text: this.text
      }
      if (this.isInNewMode){
        dataFieldsToUpdate.date = this.selected_date.toISOString();
        dataFieldsToUpdate.consumable_id = this.consumablesTags[0].consumable.document_id;
        console.log("creating new consumable log: ", dataFieldsToUpdate);
        this.createConsumableLog(dataFieldsToUpdate);
      } else {
        dataFieldsToUpdate.consumable_id = this.log_data.consumable_id;
        dataFieldsToUpdate.document_id = this.log_data.document_id;
        console.log("updating consumable log: ", dataFieldsToUpdate);
        this.updateConsumableLog(dataFieldsToUpdate);
      }
    }
  },
  mounted() {
    if (this.isInNewMode && this.currentUserAccess("ProjectLogs", this.UserActions.CREATE, this.project_id)) {
      console.log("add new consumable log");
    } else if (!this.isInNewMode && this.currentUserAccess("ProjectLogs", this.UserActions.UPDATE, this.project_id)){
      console.log("update consumable log");
      this.resource = this.log_data.parent.resource;
      this.quantity = this.log_data.quantity;
      this.text = this.log_data.text; 
    } else {
      console.log("component access denied.");
      this.$emit('close');
    }
  },
  computed: {
    isInNewMode() {
      return this.log_data.document_id === "new";
    },
    pageTitle() {
      if (this.isInNewMode) {
        return this.$t('consumable-log-view.new-log-title')
      } else {
        return this.$t('consumable-log-view.edit-log-title')
      }
    },
    quantityTitle() {
      if (this.consumablesTags[0] === undefined || this.consumablesTags[0] == null
          || this.consumablesTags[0].consumable.meta.estimation === undefined || this.consumablesTags[0].consumable.meta.estimation == null) {
        return this.$t('consumable-log-view.quantity');
      }
      let u = this.quantityUnits.find(obj => {
        return obj.id === this.consumablesTags[0].consumable.unit
      });
      return this.$t('consumable-log-view.quantity') + ((u === undefined || u === "") ? "" : "(" + this.$t(u.translationKey) + ")");
    },
    remainingQuantity(){
      let tag;
      let totalQuantity = 0;
      let totalLoggedQuantity = 0;
      let curLogSavedQuantity = 0;
      if (this.isInNewMode) {
        if(this.consumablesTags[0] === undefined || this.consumablesTags[0] == null)
           return '';
        tag = this.consumablesTags[0].consumable;
        if(tag.meta.estimation === undefined || tag.meta.estimation == null)
          return;
        totalLoggedQuantity = tag.logged_quantities;
      }
      else {
        tag = this.log_data;
        totalLoggedQuantity = tag.parent.logged_quantities;
        curLogSavedQuantity = tag.quantity;
      }
      totalQuantity = tag.meta.estimation.quantity;
      let remaining = (totalLoggedQuantity - totalQuantity - curLogSavedQuantity + this.quantity).toFixed(3);
      return ((remaining>0) ? this.$t('project-logs.exceeding') : this.$t('project-logs.remaining')) + ": " + Math.abs(remaining);
    }
  }
};
</script>

<style scoped>

.required-field {
  color: red;
  font-size: 10pt;
}
</style>
